import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { CsvDownloadMenu } from 'secondstep-components'

export const StyledCsvDownloadMenu = styled(CsvDownloadMenu)`
  align-self: flex-end;
  display: inline-flex;
  position: relative;
  z-index: 3;
  width: auto;
  max-width: none;
  flex: 0 0 auto;

  .dropdown-space-filler {
    display: none;
  }

  [class*='DownloadButton'] {
    position: relative;
    z-index: 2;
    width: auto;
    padding: 0 1.25rem 0 0;
    border: none;

    span {
      color: ${themeGet('colors.white')};
      font-family: ${themeGet('font.molde.medium')};
    }

    & > svg:first-of-type {
      width: 26px;
      height: 16px;
      margin-right: 0.5rem;
      transform: none;
      color: ${themeGet('colors.white')};
    }

    & > svg:last-of-type {
      position: absolute;
      right: 0px;
      top: 1px;
      width: 14px;
      height: 12px;
      margin-top: 0.125rem;
      color: ${themeGet('colors.white')};
    }
  }

  button {
    justify-self: flex-end;
    width: auto;
    flex: 0 0 auto;
  }

  [data-testid='csv-download-menu-infobox'] {
    display: none;
  }

  [class*='ReportLinkSeparator'] {
    justify-content: space-between;
    padding-left: 0.5625rem;
    margin: 0.5rem 0;

    span {
      margin-right: 0;
      width: 5.9375rem;
    }

    div {
      width: calc(100% - 5.9375rem);
    }
  }

  [data-testid='csv-download-menu-links'] {
    z-index: 3;
    width: 245px;
    top: 100%;
    margin-top: 0.5rem;
    left: -1px;
    border-radius: 5px;

    [class*='ReportLink-'] {
      padding: 0.1875rem 0.625rem 0.3125rem;
      margin: 0.3125rem 0 !important;

      span {
        margin-left: 0;
        color: ${themeGet('colors.darkBlue')};
        font-family: ${themeGet('font.molde.medium')};
      }

      &:hover {
        background: ${themeGet('colors.darkBlue')};

        span {
          color: ${themeGet('colors.white')};
        }
      }
    }
  }

  [class*='ErrorMsg'] {
    position: absolute;
    bottom: -18px;
  }

  ${themeGet('breakpoints.tablet')} {
    align-self: flex-start;
    // max-width: none;
  }

  @media (max-width: 730px) {
    [data-testid='csv-download-menu-links'] {
      left: 0;
    }
  }

  ${themeGet('breakpoints.mobile')} {
    [data-testid='csv-download-menu-links'] {
      right: 0;
    }
  }
`

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;

  label {
    font-size: 0.8125rem;
  }

  ${themeGet('breakpoints.mobile')} {
    justify-content: flex-start;
  }
`

export const ReportsDropdownWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: auto;
  max-width: none;
  flex: 0 0 auto;

  label {
    font-size: 0.75rem;
    line-height: 1.5rem;
    font-family: ${themeGet('font.molde.medium')};
    color: ${themeGet('colors.darkGray')};
  }

  ${themeGet('breakpoints.tablet')} {
    min-width: unset;
  }

  @media (max-width: 730px) {
    padding-left: 0;
    padding-right: 0;
  }
`
